import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "about-us" }
const _hoisted_2 = { class: "about-us-banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "about-us-content" }
const _hoisted_5 = { class: "company-profile" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "ryzz honor" }
const _hoisted_8 = { class: "ryzz-list" }
const _hoisted_9 = { class: "ryzz-viewport" }
const _hoisted_10 = { class: "honors-card" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "honors-text" }
const _hoisted_13 = { class: "xwzx" }
const _hoisted_14 = { class: "xwzx-box" }
const _hoisted_15 = { class: "news-content" }
const _hoisted_16 = ["onClick"]

import { ref, watch, onMounted, onUnmounted, reactive } from 'vue'
import { selectCommonElement, addConsult } from '@/api'
import router from '@/router';
import { ElCarousel, ElCarouselItem } from 'element-plus'
import { asynchronousRetrieval } from '@/utils'

export default /*@__PURE__*/_defineComponent({
  __name: 'AboutUsView',
  setup(__props) {

const loadUrl: any = ref({})

let timer3: any = null;
const newsList: any = ref([])
const honors = [
  {
    url: require('@/assets/images/about_us/ryzz8.jpg'),
    illustrate: ['高新技术企业']
  },
  {
    url: require('@/assets/images/about_us/ryzz1.png'),
    illustrate: ['2023上海最具投资潜力']
  },
  {
    url: require('@/assets/images/about_us/ryzz2.png'),
    illustrate: ['“创客中国”元宇宙（人工智能）']
  },
  {
    url: require('@/assets/images/about_us/ryzz3.png'),
    illustrate: ['2023数智创新优胜奖']
  },
  {
    url: require('@/assets/images/about_us/ryzz6.png'),
    illustrate: ['2024年度典型案例']
  },
  {
    url: require('@/assets/images/about_us/ryzz7.png'),
    illustrate: ['上海市创新创业大赛 优胜奖']
  },
]

const activeNewsIndex = ref(0)


const toOtherPath = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
}

onMounted(async () => {
  selectCommonElement({ columnId: 5, appId: 2 }).then((res: any) => {
    newsList.value = [...res].sort((a: any, b: any) => (a.sortNum ?? 0) - (b.sortNum ?? 0)).slice(0, 4).map((e: any) => {
      const date = new Date(e.newsTimestamp || e.createTime)
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      e.times = `${y}-${m}-${d}`
      return e;
    })
  })

  clearInterval(timer3)
  timer3 = setInterval(() => {
    activeNewsIndex.value += 1;
    if (activeNewsIndex.value > 3) {
      activeNewsIndex.value = 0;
    }
  }, 3000)

  const particle_moment_mp4: any = await asynchronousRetrieval('webimg/images/home/particles-moment.mp4');
  const banner_bg: any = await asynchronousRetrieval('webimg/images/about_us/banner-bg.png');
  const company_profile: any = await asynchronousRetrieval('webimg/images/about_us/company-profile.png');
  loadUrl.value = { particle_moment_mp4, banner_bg, company_profile }
})

onUnmounted(() => {
  clearInterval(timer3)
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: loadUrl.value.banner_bg
      }, null, 8, _hoisted_3),
      _cache[0] || (_cache[0] = _createElementVNode("div", null, "关于我们", -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "introduce" }, [
        _createElementVNode("div", null, "公司介绍"),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, "混空是一家专注元宇宙数实融合场景建设的公司，深耕XR+AI技术突破，为文娱、商业、工业、教育行业提供综合解决方案。"),
          _createElementVNode("div", null, "混空自研多项核心底层技术，专注于视觉+AI算法融合，实现厘米级空间定位。核心产品混空 Studio（智能体）是一款AI+AR元宇宙内容创作与分发平台，帮助用户一站式完成空间数字化建模和元宇宙互动营销场景创作，并通过XR眼镜、手机等实现跨端数实融合体验。"),
          _createElementVNode("div", null, "公司获得国家级高新技术企业认定、国家双软企业认定和国家科技型中小企业认定，已申请70多项知识产权，并凭借数实融合技术多次斩获国内投资价值类奖项，成为元宇宙头部公司。")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: loadUrl.value.company_profile
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "荣誉资质", -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(ElCarousel), {
              interval: 3000,
              type: "card",
              height: "400rem",
              arrow: 'always',
              autoplay: false,
              "indicator-position": 'none'
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(honors, (item, index) => {
                  return _createVNode(_unref(ElCarouselItem), { key: index }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("img", {
                          src: item.url
                        }, null, 8, _hoisted_11),
                        _createElementVNode("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.illustrate, (e, i) => {
                            return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(e), 1))
                          }), 128))
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024)
                }), 64))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title-font-style title" }, "公司动态", -1)),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, (e, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                onClick: ($event: any) => (toOtherPath(e.relatedHtmlId, e.title)),
                class: _normalizeClass(activeNewsIndex.value == i ? 'active' : '')
              }, [
                _createElementVNode("div", null, _toDisplayString(e.title), 1),
                _createElementVNode("div", null, _toDisplayString(e.times), 1)
              ], 10, _hoisted_16))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})